import { render, staticRenderFns } from "./UserBranches.vue?vue&type=template&id=38b1cf43&scoped=true"
import script from "./UserBranches.vue?vue&type=script&lang=js"
export * from "./UserBranches.vue?vue&type=script&lang=js"
import style0 from "./UserBranches.vue?vue&type=style&index=0&id=38b1cf43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1cf43",
  null
  
)

export default component.exports